import {
  fetchStatisticsOfActivity,
  fetchGetTrendChart1,
  fetchGetTrendChart2,
  fetchGetCPABonusReport,
  fetchGetCPABonusSum,
} from '@/api/statistics'

const statistics = {
  namespaced: true,
  state: {
    clickNumber: undefined,
    newRegistrations: undefined,
    newRealTraders: undefined,
  },
  mutations: {
    SET_CLICK_NUMBER: (state, clickNumber) => {
      state.clickNumber = clickNumber
    },
    SET_NEW_REGISTRATIONS: (state, newRegistrations) => {
      state.newRegistrations = newRegistrations
    },
    SET_NEW_REAL_TRADERS: (state, newRealTraders) => {
      state.newRealTraders = newRealTraders
    },
  },
  actions: {
    GetAllOfActivity(state, data) {
      return fetchStatisticsOfActivity(data)
    },
    GetTrendChart1(state, data) {
      return Promise.all([
        fetchGetTrendChart1({ ...data, operType: 1 }),
        fetchGetTrendChart1({ ...data, operType: 2 }),
        fetchGetTrendChart1({ ...data, operType: 3 }),
        fetchGetTrendChart1({ ...data, operType: 4 }),
        fetchGetTrendChart1({ ...data, operType: 5 }),
      ])
    },
    GetTrendChart2(state, data) {
      return fetchGetTrendChart2(data)
    },
    GetCPABonusReport(state, data) {
      return Promise.all([
        fetchGetCPABonusReport(data),
        fetchGetCPABonusSum(data),
      ])
    },
  },
}

export default statistics
